<script setup>
import {ref} from "vue"

const props = defineProps({
  // 标题
  title: {
    type: String,
    default: '信息'
  },
  // 是否展示
  show: {
    type: Boolean,
    default: true
  },
  // 是否展示标题色块
  hasTitleLine: {
    type: Boolean,
    default: true
  },
  // 标题竖线颜色
  titleLineColor: {
    type: String,
    default: '#796CB4'
  },
  row: {
    type: Boolean,
    default: false
  },
  mg_b: {
    type: Number,
    default: 24
  },
  // 标题后示例是否展示
  isShowExamples: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['clickTitleAfter'])

// 点击标题后按钮
const handleClick = () => {
  emit('clickTitleAfter')
}

</script>

<template>
  <div v-show="show">
    <div :class="['ytCard_box', row ? 'flex_left': '']" :style="`margin-bottom:${props.mg_b}px;`">
      <div :class="['ytCard_title_box', 'flex_left', row ? 'no_mb': '']">
        <div class="ytCard_title_line" v-if="props.hasTitleLine" :style="`background: ${props.titleLineColor};`"></div>
        <div :class="['ytCard_title', row ? 'no_mr': '']" v-text="props.title" ></div>
        <slot name="subtitle"></slot>
        <div v-show="props.isShowExamples">
          <el-link style="color: #796CB4;" @click="handleClick">示例</el-link>
        </div>
      </div>
      <div>
        <slot name="container"></slot>
      </div>
    </div>
  </div>
</template>

<style scoped>
.ytCard_box {
  width: 100%;
  text-align: left;
  padding: 15px 0 0 20px;
  .ytCard_title_box{
    margin-bottom: 20px;
    box-sizing: border-box;
    .ytCard_title_line {
      width: 4px;
      height: 20px;
      background: #796CB4;
      border-radius: 2px;
      margin-right: 15px;
    }
    .ytCard_title {
      margin-right: 20px;
      font-weight: bold;
      font-size: 22px;
      color: #000000;
    }
  }
  .no_mb{
    margin-bottom: 0 !important;
  }
  .no_mr{
    margin-right: 0 !important;
  }
}
</style>
